import { render, staticRenderFns } from "./userStaticCard.vue?vue&type=template&id=38c49c55&scoped=true&"
import script from "./userStaticCard.vue?vue&type=script&lang=js&"
export * from "./userStaticCard.vue?vue&type=script&lang=js&"
import style0 from "./userStaticCard.vue?vue&type=style&index=0&id=38c49c55&lang=less&scoped=true&"
import style1 from "./userStaticCard.vue?vue&type=style&index=1&id=38c49c55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c49c55",
  null
  
)

export default component.exports